import React from "react";
import { Card, CardBody } from "reactstrap";

export const StatCard = ({ icon, title, value, color = "primary", iconBg = "#f5f5f5" }) => (
    <Card className="mb-2 border-0 shadow-sm">
        <CardBody className="p-3">
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <small className="text-muted d-block mb-1">{title}</small>
                    <h4 className={`mb-0 text-${color} fw-bold`}>{value || 0}</h4>
                </div>
                <div className="avatar-sm">
                    <span className="avatar-title rounded-circle" style={{ backgroundColor: iconBg }}>
                        <i className={`${icon} text-${color} fs-4`}></i>
                    </span>
                </div>
            </div>
        </CardBody>
    </Card>
);